<!-- Header tabla -->
<div id="header-container">
  <p class="subheading-01-semi-bold">Nombre</p>
  <p class="subheading-01-semi-bold">Usuario</p>
  <p class="subheading-01-semi-bold">Email</p>
  <p class="subheading-01-semi-bold">Acciones</p>
</div>

<!-- Row Item -->
<div
  class="row-item"
  *ngFor="let item of this.users; let i = index"
  [ngClass]="{ 'color-1': i % 2 == 0 }"
>
  <p class="subheading-01-semi-bold">{{ item.name }} {{ item.lastname }}</p>
  <p class="subheading-01-semi-bold">{{ item.user }}</p>
  <p class="subheading-01-semi-bold">{{ item.email }}</p>
  <div class="actions-container">
    <qr-button
      [config]="buttonModificate"
      (click)="onModificate('modificate', item.id)"
    ></qr-button>
    <qr-button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      [config]="kebabButtonConfig"
      class="button-menu"
      matTooltip="Mas opciones"
    ></qr-button>
    <!-- Menu Options -->
    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <div class="menu-billing" (click)="onActionMenu('reset', item)">
          <qr-icon name="password" color="grey-600"></qr-icon>
          <p class="subheading-01-semi-bold">Reiniciar contraseña</p>
        </div>
      </button>
      <button mat-menu-item>
        <div class="menu-billing" (click)="onActionMenu('delete', item)">
          <qr-icon name="delete" color="grey-600"></qr-icon>
          <p class="subheading-01-semi-bold">Eliminar usuario</p>
        </div>
      </button>
    </mat-menu>
    <!-- Menu Options -->
  </div>
</div>
<!-- Row Item -->

<!-- Header tabla -->
